const PILI_BLUE = "#1C3D55";
const PILI_LIME = "#C9DD3B";
const PILI_DARK = "#0b0c0f";
const PILI_MUTED = "#5A5A5A";
const PILI_LIGHT_BLUE_BG = "#eaf2ff";

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: "100vh",
    backgroundColor: PILI_LIGHT_BLUE_BG,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  header: {
    padding: "24px",
    backgroundColor: PILI_BLUE,
  },
  logo: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    objectFit: "contain" as const,
  },
  main: {
    maxWidth: "720px",
    margin: "0 auto",
    padding: "48px 24px 80px",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    padding: "48px",
    boxShadow: "0 4px 24px rgba(28, 61, 85, 0.08)",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    color: PILI_DARK,
    marginBottom: "8px",
    letterSpacing: "-0.02em",
  },
  subtitle: {
    fontSize: "14px",
    color: PILI_MUTED,
    marginBottom: "40px",
    paddingBottom: "24px",
    borderBottom: `2px solid ${PILI_LIME}`,
  },
  section: {
    marginBottom: "32px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: PILI_BLUE,
    marginBottom: "12px",
  },
  paragraph: {
    fontSize: "15px",
    color: PILI_MUTED,
    lineHeight: "1.7",
    marginBottom: "12px",
  },
  emailLink: {
    color: PILI_BLUE,
    textDecoration: "none",
    fontWeight: "600",
  },
  link: {
    color: PILI_BLUE,
    textDecoration: "none",
    fontWeight: "500",
  },
};

export default function SupportPage() {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <a href="/">
          <img src="/app-icon.png" alt="Pili" style={styles.logo} />
        </a>
      </header>

      <main style={styles.main}>
        <div style={styles.card}>
          <h1 style={styles.title}>Support</h1>
          <p style={styles.subtitle}>We're here to help with any questions about Pili.</p>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>Contact Us</h2>
            <p style={styles.paragraph}>
              For questions, issues, or feedback, reach out to us at{" "}
              <a href="mailto:support@paypili.com" style={styles.emailLink}>
                support@paypili.com
              </a>
              . We typically respond within one business day.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>Payment Issues</h2>
            <p style={styles.paragraph}>
              Payments on Pili are processed by Stripe. If you have questions about a specific
              transaction, please include the date and amount when contacting us so we can look into
              it quickly.
            </p>
          </div>

          <div style={{ ...styles.section, marginBottom: 0 }}>
            <h2 style={styles.sectionTitle}>Legal</h2>
            <p style={{ ...styles.paragraph, marginBottom: 0 }}>
              Review our{" "}
              <a href="/terms" style={styles.link}>
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="/privacy" style={styles.link}>
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
